import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DashboardLayout from "tools/LayoutContainers/DashboardLayout";
import DashboardNavbar from "tools/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const presidentsRows = [
  { name: "Bill Gross (2023/2024)", company: "PPC Flexible Packaging", role: "Immediate Past President", term: "2024/2025", category: "Packaging", email: "Bill.Gross@ppcflex.com", address: "n/a" },
  { name: "Dean Modglin (2021/2022)", company: "Lesaffre", role: "Past President", term: "Past President", category: "Ingredients", email: "d.modglin@lesaffre.com", address: "n/a" },
  { name: "DJ LeCrone (2019/2020)", company: "LeMatic", role: "Past President", term: "Past President", category: "Equipment", email: "djlecrone@lematic.com", address: "n/a" },
  { name: "John Hellman (2017/2018) - Retired", company: "Retired - McGahee, Lacy & Associates", role: "Past President", term: "Past President", category: "Packaging", email: "jrhellman57@gmail.com", address: "n/a" },
  { name: "Thomas McCurry (2015/2016)", company: "Cain Food", role: "Past President", term: "Past President", category: "Ingredients", email: "t.mccurry@cainfood.com", address: "n/a" },
  { name: "Rick McGrath (2013/2014)", company: "Lockton Companies", role: "Past President", term: "Past President", category: "Insurance", email: "rmcgrath@lockton.com", address: "n/a" },
  { name: "Tim S. Miller (2011/2012) - Retired", company: "Retired - Grain Craft", role: "Past President", term: "Past President", category: "Milling", email: "tmiller@graincraft.com", address: "n/a" },
  { name: "Gary M. Edwards (2009/2010) - Retired", company: "Retired - Lallemand", role: "Past President", term: "Past President", category: "Ingredients", email: "gedwards@lallemand.com", address: "n/a" },
  { name: "Brad Burris (2007/2008)", company: "D.Thomas & Associates", role: "Past President", term: "Past President", category: "Packaging", email: "jbburris@dthos.com", address: "n/a" },
  { name: "Mike Gude (2005/2006)", company: "Sosland Publishing", role: "Past President", term: "Past President", category: "Publishing", email: "mgude@sosland.com", address: "n/a" },
  { name: "Gary Cain (2003/2004) - Retired", company: "Retired - Cain Food", role: "Past President", term: "Past President", category: "Ingredients", email: "gcain128@icloud.com", address: "n/a" },
  { name: "Fred Springer (2001/2002) - Retired", company: "Retired - Burford Corp.", role: "Past President", term: "Past President", category: "Equipment", email: "fspringer@outlook.com", address: "n/a" },
  { name: "John Riesch - Retired", company: "Retired - Lesaffre", role: "Past President", term: "Past President", category: "Ingredients", email: "jnriesch45@gmail.com", address: "n/a" },
  { name: "William T. McCurry - Retired", company: "Retired - Manildra", role: "Past President", term: "Past President", category: "Ingredients", email: "wtmccurry@hotmail.com", address: "n/a" },
  { name: "James R. Lynch", company: "D. Thomas & Associates", role: "Past President", term: "Past President", category: "Packaging", email: "n/a", address: "n/a" },
  { name: "David S. Murphy", company: "Mother Murphy's Labs", role: "Past President", term: "Past President", category: "Ingredients", email: "n/a", address: "n/a" },
];

function PresidentsGrid({ rows, onSelect }) {
  return (
    <MDBox p={3}>
      <MDBox mb={3} p={2}>
        <MDTypography variant="h5" fontWeight="medium" pb={2}>
          Presidents
        </MDTypography>
        <Grid container spacing={2}>
          {rows.map((member) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={`${member.name}-${member.company}`}>
              <Card
                onClick={() => onSelect(member)}
                sx={{
                  p: 2,
                  height: "100%",
                  cursor: "pointer",
                  border: "1px solid",
                  borderColor: "grey.300",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: 4,
                    borderColor: "primary.main",
                  },
                }}
              >
                <MDTypography variant="h6" fontWeight="bold" mb={1}>
                  {member.name}
                </MDTypography>
                <MDTypography variant="button" color="text" display="block">
                  {member.role}
                </MDTypography>
                <MDTypography variant="button" color="text" display="block">
                  {member.company}
                </MDTypography>
                <MDTypography variant="button" color="text" display="block">
                  {member.category}
                </MDTypography>
              </Card>
            </Grid>
          ))}
        </Grid>
      </MDBox>
    </MDBox>
  );
}

export default function PastPresidents() {
  const [selectedMember, setSelectedMember] = useState(null);

  return (
    <DashboardLayout>
      <DashboardNavbar onSsearch={false} />
      <MDTypography variant="h5" fontWeight="medium" pb={3}>
        ATBI Previous Presidents
      </MDTypography>
      <MDBox display="flex" alignItems="center">
        <Card sx={{ overflow: "visible", width: "100%" }}>
          <PresidentsGrid rows={presidentsRows} onSelect={setSelectedMember} />
        </Card>
      </MDBox>

      <Dialog open={Boolean(selectedMember)} onClose={() => setSelectedMember(null)} fullWidth maxWidth="sm">
        <DialogTitle>{selectedMember?.name}</DialogTitle>
        <DialogContent>
          <MDTypography variant="button" color="text" display="block" mb={1}>
            <strong>Role:</strong> {selectedMember?.role || "N/A"}
          </MDTypography>
          <MDTypography variant="button" color="text" display="block" mb={1}>
            <strong>Term:</strong> {selectedMember?.term || "N/A"}
          </MDTypography>
          <MDTypography variant="button" color="text" display="block" mb={1}>
            <strong>Company:</strong> {selectedMember?.company || "N/A"}
          </MDTypography>
          <MDTypography variant="button" color="text" display="block" mb={1}>
            <strong>Category:</strong> {selectedMember?.category || "N/A"}
          </MDTypography>
          <MDTypography variant="button" color="text" display="block" mb={1}>
            <strong>Email:</strong> {selectedMember?.email || "N/A"}
          </MDTypography>
          <MDTypography variant="button" color="text" display="block">
            <strong>Address:</strong> {selectedMember?.address || "N/A"}
          </MDTypography>
        </DialogContent>
      </Dialog>
    </DashboardLayout>
  );
}
